import config from '../data/config';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import locales from '../locales';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: locales,

    react: {
      useSuspense: false,
    },
    lng: config.defaultLng,
    fallbackLng: config.defaultLng,
    supportedLngs: config.supportedLngs,
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false,
    },
  });
